import React from 'react';
import {
  ChartBarIcon,
  UserGroupIcon,
  DocumentTextIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

const Overview: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Dashboard Overview</h1>
      <p className="section-description">
        Welcome to the Dashboard Documentation. This guide will help you understand
        and navigate through the various features and functionalities of the
        dashboard.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
        <div className="feature-item">
          <ChartBarIcon className="feature-icon" />
          <div className="feature-text">
            <h3 className="feature-title">Dashboard</h3>
            <p className="feature-description">
              Get an overview of your system's performance and key metrics.
            </p>
          </div>
        </div>

        <div className="feature-item">
          <UserGroupIcon className="feature-icon" />
          <div className="feature-text">
            <h3 className="feature-title">Teams & Members</h3>
            <p className="feature-description">
              Manage your teams and members with ease.
            </p>
          </div>
        </div>

        <div className="feature-item">
          <DocumentTextIcon className="feature-icon" />
          <div className="feature-text">
            <h3 className="feature-title">Content Management</h3>
            <p className="feature-description">
              Create and manage your content efficiently.
            </p>
          </div>
        </div>

        <div className="feature-item">
          <UsersIcon className="feature-icon" />
          <div className="feature-text">
            <h3 className="feature-title">User Management</h3>
            <p className="feature-description">
              Handle user accounts and permissions effectively.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Getting Started
        </h2>
        <p className="text-gray-600 mb-4">
          To begin using the dashboard, follow these steps:
        </p>
        <ol className="list-decimal list-inside space-y-2 text-gray-600">
          <li>Log in to the dashboard using your credentials</li>
          <li>Navigate through the sidebar menu to access different sections</li>
          <li>Use the search functionality to find specific items</li>
          <li>Refer to the documentation for detailed information about each feature</li>
        </ol>
      </div>
    </div>
  );
};

export default Overview; 